import type { TFunction } from 'i18next';

import type { GameAudience } from '../../../stores/game/types';

const GAME_AUDIENCE_LABEL_KEYS = {
  royal_crowns: 'games.royalCrowns',
  dynasty: 'tiersTitleCase.dynasty',
} as const satisfies Record<GameAudience, string>;

// A group added on the backend before this app knows it is dropped rather than shown as a raw key.
export const audienceBadgeText = (audiences: GameAudience[], t: TFunction): string | null => {
  const names = audiences
    .filter((audience) => audience in GAME_AUDIENCE_LABEL_KEYS)
    .map((audience) => t(GAME_AUDIENCE_LABEL_KEYS[audience]));

  return names.length ? t('games.onlyFor', { audiences: names.join(' + ') }) : null;
};
